<template>
  <div>
    <b-table
      no-border-collapse
      bordered
      outlined
      hover
      responsive
      :items="items"
      :fields="fields"
    >
    </b-table>
  </div>
</template>

<script>
import { NumberOfdigitsafterDecimalIsOne } from '../../services/lib/NumberofDigitsafterDecimals';
export default {
  name: 'Result',
  props: {
    gridData: {
      type: Array,
      required: true,
    },
  },

  mounted() {
    this.items = this.tableData;
  },
  beforeUpdate() {
    this.gridData.forEach(row => {
      const rowData = {
        'User types': this.convertTonumberwithCommas(row['User types']),
        Region: row['Region'],
        Users: row['Users'],
        'Term options': row['Term options'],
        '3 Year costs':
          '$' +
          this.convertTonumberwithCommas(Number(row['3 Yr Term']).toFixed(2)),
        'Per annum':
          '$' +
          this.convertTonumberwithCommas(Number(row['Per annum']).toFixed(2)),
        'Per month':
          '$' +
          this.convertTonumberwithCommas(Number(row['Per month']).toFixed(2)),

        'Per user/month': '$' + Number(row['Per month/User']).toFixed(2),
      };
      if (
        NumberOfdigitsafterDecimalIsOne(
          Number(row['Per month/User']).toFixed(2)
        )
      ) {
        rowData['Per user/month'] =
          '$' + Number(row['Per month/User']).toFixed(2) + '0';
      }
      this.tableData.push(rowData);
    });

    let year_calulatedData = 0;
    let perannumCalculatedData = 0;

    let perMonthCalculatedData = 0;
    this.gridData.forEach(item => {
      year_calulatedData += item['3 Yr Term'];
      perannumCalculatedData += Number(item['Per annum']);
      perMonthCalculatedData += Number(item['Per month']);
    });
    const calculatedFooter = {
      'User types': '',
      Region: '',
      Users: '',
      '3 Year costs':
        '$' + this.convertTonumberwithCommas(year_calulatedData.toFixed(2)),
      'Per annum':
        '$' + this.convertTonumberwithCommas(perannumCalculatedData.toFixed(2)),
      'Per month':
        '$' + this.convertTonumberwithCommas(perMonthCalculatedData.toFixed(2)),
      'Per user/month': '',
      _cellVariants: {
        '3 Year costs': 'dark',
        'Per annum': 'dark',
        'Per month': 'dark',
      },
    };
    this.tableData.push(calculatedFooter);
  },

  data() {
    return {
      fields: [
        {
          label: 'User types',
          key: 'User types',
          thStyle: { background: '#DBDBDB', textAlign: 'left' },
          class: 'leftAlignRowData',
        },
        {
          label: 'Term options',
          key: 'Term options',
          thStyle: { background: '#DBDBDB', textAlign: 'left' },
          class: 'leftAlignRowData',
        },
        {
          label: 'Region',
          key: 'Region',
          thStyle: { background: '#DBDBDB', textAlign: 'left' },
          class: 'leftAlignRowData',
        },
        {
          label: 'Users',
          key: 'Users',
          thStyle: { background: '#DBDBDB' },
        },
        {
          label: '3 Year costs',
          key: '3 Year costs',
          thStyle: { background: '#ededed' },
        },
        {
          label: 'Yearly costs',
          key: 'Per annum',
          thStyle: { background: '#ededed' },
        },
        {
          label: 'Per month',
          key: 'Per month',
          thStyle: { background: '#ededed' },
        },
        {
          label: 'Per user/month',
          key: 'Per user/month',
          thStyle: { background: '#ededed' },
        },
      ],
      items: [],
      tableData: [],
    };
  },
};
</script>
<style lang="scss" scoped>
.light {
  background: #ededed;
}
.thead-dark {
  background: #000;
}
/deep/.table {
  box-shadow: 0px 0px 24px rgba(217, 217, 217, 0.5);
}

/deep/.table > tbody > tr > td {
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  vertical-align: middle;
  color: #000;
}
/deep/.table > tbody > tr > td.leftAlignRowData {
  text-align: left;
}
/deep/.table > thead > tr > th {
  font-size: 24px;
  font-weight: 600;
}
// /deep/.table > thead > tr > th > div {
//   margin-bottom: 15px;
// }
/deep/.table > thead > tr > th:last-child > div {
  margin-bottom: 0px;
}
/deep/.table > thead > tr > th:nth-child(1) {
  width: 20%;
}
/deep/.table > thead > tr > th:nth-child(2) {
  width: 20%;
}
/deep/.table > thead > tr > th:nth-child(3) {
  width: 10%;
}
/deep/.table > thead > tr > th:nth-child(4) {
  width: 15%;
}
/deep/.table > thead > tr > th:nth-child(5) {
  width: 15%;
}
/deep/.table > thead > tr > th:nth-child(6) {
  width: 15%;
}
/deep/.table > thead > tr > th:nth-child(7) {
  width: 5%;
}

/deep/.table > tbody > tr:last-child > td:nth-child(1) {
  border: none;
}
/deep/.table > tbody > tr:last-child > td:nth-child(2) {
  border: none;
}
/deep/.table > tbody > tr:last-child > td:nth-child(3) {
  border: none;
}
/deep/.table > tbody > tr:last-child > td:nth-child(4) {
  color: #fff;
}
/deep/.table > tbody > tr:last-child > td:nth-child(5) {
  color: #fff;
}
/deep/.table > tbody > tr:last-child > td:nth-child(6) {
  color: #fff;
}
/deep/.table > tbody > tr:last-child > td:nth-child(7) {
  color: #fff;
}
@media print {
  /deep/.table-responsive {
    width: 100%;
    overflow: visible;
  }
}
</style>
